import { render, staticRenderFns } from "./PreparationLimitModification.vue?vue&type=template&id=1a3bf52f"
import script from "./PreparationLimitModification.vue?vue&type=script&lang=ts"
export * from "./PreparationLimitModification.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports